<div class="common-header-app madero-style" ui-view></div>
